// Sorts floor plans by their order property.
// Floor plans with an order come first (sorted numerically), followed by those without.
export function sortFloorPlans<T>(floorPlans: T[]): T[] {
  return [...floorPlans].sort((a, b) => {
    const orderA = (a as any).order;
    const orderB = (b as any).order;
    if (orderA != null && orderB != null) return orderA - orderB;
    if (orderA != null) return -1;
    if (orderB != null) return -1;
    return 0;
  });
}
